var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"typeList-content"},[_c('content-list',{attrs:{"title":_vm.contentTitle,"list":_vm.contentList},on:{"refreshList":_vm.refreshList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }